const USER_ROLES = {
  "seller": "seller",
  "dealer": "dealer",
  "buyer": "buyer",
  "admin": "admin",
  "agent": "agent"
};

const USER_ROLES_DOMAINS = {
  "seller": process.env.REACT_APP_SELLER_DOMAIN,
  "dealer": process.env.REACT_APP_DEALER_DOMAIN,
  "buyer": process.env.REACT_APP_BUYER_DOMAIN,
  "admin": process.env.REACT_APP_ADMIN_DOMAIN,
  "agent": process.env.REACT_APP_AGENT_DOMAIN
};

export {
  USER_ROLES,
  USER_ROLES_DOMAINS
};